import { apiSlice } from "./apiSlice";

export const userActionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    userActions: builder.mutation({
      query: (params) => ({
        url: "/api/v3/crm/user_actions",
        method: "GET",
        params: { ...params },
      }),
    }),
  }),
});

export const { useUserActionsMutation } = userActionsApiSlice;
